"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _index = require("avo/index");
var _view = _interopRequireDefault(require("./view"));
var _state = _interopRequireDefault(require("./state"));
var _ErrorBoundary = require("ErrorBoundary");
var Sentry = _interopRequireWildcard(require("@sentry/browser"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
(0, _index.subscribeToAvo)();
try {
  var _APP_CONFIG, _APP_CONFIG$sentry, _APP_CONFIG2, _APP_CONFIG3, _APP_CONFIG3$sentry, _APP_CONFIG4, _APP_CONFIG4$sentry, _APP_CONFIG5, _APP_CONFIG5$sentry;
  Sentry.init({
    enabled: (_APP_CONFIG = APP_CONFIG) === null || _APP_CONFIG === void 0 ? void 0 : (_APP_CONFIG$sentry = _APP_CONFIG.sentry) === null || _APP_CONFIG$sentry === void 0 ? void 0 : _APP_CONFIG$sentry.enabled,
    dsn: (_APP_CONFIG2 = APP_CONFIG) === null || _APP_CONFIG2 === void 0 ? void 0 : _APP_CONFIG2.sentry.dsn,
    environment: (_APP_CONFIG3 = APP_CONFIG) === null || _APP_CONFIG3 === void 0 ? void 0 : (_APP_CONFIG3$sentry = _APP_CONFIG3.sentry) === null || _APP_CONFIG3$sentry === void 0 ? void 0 : _APP_CONFIG3$sentry.env,
    debug: !IS_PROD,
    release: APP_VERSION,
    sampleRate: (_APP_CONFIG4 = APP_CONFIG) === null || _APP_CONFIG4 === void 0 ? void 0 : (_APP_CONFIG4$sentry = _APP_CONFIG4.sentry) === null || _APP_CONFIG4$sentry === void 0 ? void 0 : _APP_CONFIG4$sentry.sampleRate,
    tracesSampleRate: (_APP_CONFIG5 = APP_CONFIG) === null || _APP_CONFIG5 === void 0 ? void 0 : (_APP_CONFIG5$sentry = _APP_CONFIG5.sentry) === null || _APP_CONFIG5$sentry === void 0 ? void 0 : _APP_CONFIG5$sentry.tracesSampleRate,
    maxBreadcrumbs: 10
  });
  var trackerProperties = window.trackerProperties;
  if (trackerProperties && trackerProperties.analyticsId) {
    Sentry.setUser({
      id: trackerProperties.analyticsId
    }); // this is being set by web repo code

    Sentry.setExtras({
      userId: trackerProperties === null || trackerProperties === void 0 ? void 0 : trackerProperties.guestId,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      created_at: trackerProperties === null || trackerProperties === void 0 ? void 0 : trackerProperties.createdAt,
      path: window.location.href
    });
  }
} catch (e) {
  console.error(e);
}
var AuthSignin = function AuthSignin(_ref) {
  _objectDestructuringEmpty(_ref);
  return /*#__PURE__*/_react["default"].createElement(_ErrorBoundary.ErrorBoundary, {
    "data-sentry-element": "ErrorBoundary",
    "data-sentry-component": "AuthSignin",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_state["default"], {
    "data-sentry-element": "AuthSigninProvider",
    "data-sentry-source-file": "index.tsx"
  }, /*#__PURE__*/_react["default"].createElement(_view["default"], {
    "data-sentry-element": "AuthSigninView",
    "data-sentry-source-file": "index.tsx"
  })));
};
var container = document.getElementById('auth-signin-container-wrap');
if (container) {
  Promise.resolve().then(function () {
    return _interopRequireWildcard(require('react-dom/client'));
  }).then(function (_ref2) {
    var createRoot = _ref2.createRoot;
    var root = createRoot(container);
    root.render( /*#__PURE__*/_react["default"].createElement(AuthSignin, null));
  });
}
var _default = AuthSignin;
exports["default"] = _default;